import { useState } from "react";
import { copyToClipboard } from "../utils";

const TileMLD = ({ data = {}, t }) => {
  const [copied, setCopied] = useState(false);
  const str = (v) => (v != null ? String(v).trim() : "");

  const ip = str(data.ip_address);
  const country = str(data.country);
  const carrier = str(data.carrier);
  const adIdType = str(data.advertising_id_type);
  const adId = str(data.advertising_id);
  const manufacturer = str(data.manufacturer);
  const deviceModel = str(data.device_model);
  const timestamp = str(data.bazze_timestamp).split(" ")[0]; // date only

  const lat = data.latitude != null ? parseFloat(data.latitude) : null;
  const lng = data.longitude != null ? parseFloat(data.longitude) : null;
  const coords =
    lat != null && lng != null ? `${lat.toFixed(4)}, ${lng.toFixed(4)}` : "";

  if (!ip && !carrier && !country) return null;

  const handleCopy = async (e) => {
    e.stopPropagation();
    await copyToClipboard(adId || ip);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {/* Top row: country badge + IP + pills */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* Country badge — mirrors carrier code chip */}
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              background: t.labelBg,
              border: `1px solid ${t.labelBorder}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.04em",
              color: t.textSecondary,
              fontFamily: "monospace",
            }}
          >
            {(country || "MLD").slice(0, 4).toUpperCase()}
          </div>

          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            {/* IP address — primary identifier */}
            {ip && (
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: t.textPrimary,
                  fontFamily: "monospace",
                }}
              >
                {ip}
              </span>
            )}

            {/* Ad ID type badge */}
            {adIdType && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.badgeBg,
                  border: `1px solid ${t.badgeBorder}`,
                  color: t.badgeText,
                  textTransform: "uppercase",
                }}
              >
                {adIdType}
              </span>
            )}

            {/* Timestamp */}
            {timestamp && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                }}
              >
                {timestamp}
              </span>
            )}
          </div>
        </div>

        {/* Carrier / device line */}
        {(carrier || manufacturer || deviceModel) && (
          <p
            style={{
              fontSize: 11,
              color: t.textMuted,
              margin: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {[carrier, manufacturer, deviceModel].filter(Boolean).join(" · ")}
          </p>
        )}

        {/* Coords line */}
        {coords && (
          <p
            style={{
              fontSize: 11,
              color: t.textMuted,
              margin: 0,
              fontFamily: "monospace",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {coords}
          </p>
        )}

        {/* Ad ID copy row — mirrors BOL copy row */}
        {(adId || ip) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            <button
              onClick={handleCopy}
              type="button"
              aria-label="Copy ID"
              style={{
                flexShrink: 0,
                padding: 6,
                borderRadius: 8,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                color: copied ? t.successText : t.textMuted,
                transition: "color 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = t.pillHoverBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
              }}
            >
              {copied ? (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              ) : (
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="9" y="9" width="13" height="13" rx="2" />
                  <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                </svg>
              )}
            </button>
            <p
              style={{
                fontSize: 11,
                color: t.textMuted,
                margin: 0,
                fontFamily: "monospace",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
              title={adId || ip}
            >
              {adId || ip}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TileMLD;
